"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioCardGroup = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@headlessui/react");
var classnames_1 = require("classnames");
var react_2 = require("react");
var fonts_1 = require("../Typography/fonts");
var RadioCard_1 = require("./RadioCard");
var RadioCardGroup = function (_a) {
    var items = _a.items, _b = _a.orientation, orientation = _b === void 0 ? 'vertical' : _b, onChange = _a.onChange, value = _a.value, disabled = _a.disabled, label = _a.label;
    var _c = (0, react_2.useState)(value >= 0 ? items[value] : {}), selected = _c[0], setSelected = _c[1];
    var handleChange = function (item) {
        setSelected(item);
        onChange === null || onChange === void 0 ? void 0 : onChange(0, item);
    };
    var isVertical = orientation === 'vertical';
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "squid-w-full squid-px-4" }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "squid-w-full" }, { children: (0, jsx_runtime_1.jsxs)(react_1.RadioGroup, __assign({ value: selected, onChange: handleChange, disabled: disabled }, { children: [label && ((0, jsx_runtime_1.jsx)(react_1.RadioGroup.Label, __assign({ className: fonts_1.fontLabelClasses.strong.base.default }, { children: label }))), (0, jsx_runtime_1.jsx)("div", __assign({ className: (0, classnames_1.default)('squid-gap-component-radio-card-group-space-base squid-flex squid-flex-col', {
                            'md:squid-flex-row': !isVertical,
                            'squid-mt-4': !!label,
                        }) }, { children: items.map(function (item) {
                            var label = ['string', 'number'].includes(typeof item)
                                ? item.toString()
                                : item.label;
                            var helpText = ['string', 'number'].includes(typeof item)
                                ? item.toString()
                                : item.helpText;
                            return ((0, jsx_runtime_1.jsx)(RadioCard_1.RadioCard, { label: label, helpText: helpText, value: item }, label));
                        }) }))] })) })) })));
};
exports.RadioCardGroup = RadioCardGroup;
